// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortcuts-grid {
  display: inline-grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.shortcuts-grid .shortcut-item {
  position: relative;
  width: 100%;
  min-height: 160px;
  border-radius: 35px;
  /* height: 0;
  padding-bottom: 100%; */
}

.shortcuts-container {
  /* width: 35%; */
}

@media (max-width: 1200px) {
  .shortcuts-container {
    width: 100%;
  }

  .shortcuts-grid {
    display: inline-grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
  }
}

.payment-icon-item {
  max-width: 30%;
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.payment-icon-item:hover {
  transform: scale(1.1);
  opacity: 1;
}

.payment-icon-item.inactive {
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.payment-icon-item.inactive:hover {
  transform: scale(1.1);
  opacity: 1;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBvcnRhbC1pZGVudGl0eS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usb0JBQW9CO0VBQ3BCLDBDQUEwQztFQUMxQyxTQUFTO0FBQ1g7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIsV0FBVztFQUNYLGlCQUFpQjtFQUNqQixtQkFBbUI7RUFDbkI7eUJBQ3VCO0FBQ3pCOztBQUVBO0VBQ0UsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0U7SUFDRSxXQUFXO0VBQ2I7O0VBRUE7SUFDRSxvQkFBb0I7SUFDcEIsc0NBQXNDO0lBQ3RDLFNBQVM7RUFDWDtBQUNGOztBQUVBO0VBQ0UsY0FBYztFQUNkLDJEQUEyRDtBQUM3RDs7QUFFQTtFQUNFLHFCQUFxQjtFQUNyQixVQUFVO0FBQ1o7O0FBRUE7RUFDRSwyREFBMkQ7QUFDN0Q7O0FBRUE7RUFDRSxxQkFBcUI7RUFDckIsVUFBVTtBQUNaIiwiZmlsZSI6InBvcnRhbC1pZGVudGl0eS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNob3J0Y3V0cy1ncmlkIHtcbiAgZGlzcGxheTogaW5saW5lLWdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyIDFmciAxZnIgMWZyIDFmcjtcbiAgZ2FwOiAyMHB4O1xufVxuXG4uc2hvcnRjdXRzLWdyaWQgLnNob3J0Y3V0LWl0ZW0ge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHdpZHRoOiAxMDAlO1xuICBtaW4taGVpZ2h0OiAxNjBweDtcbiAgYm9yZGVyLXJhZGl1czogMzVweDtcbiAgLyogaGVpZ2h0OiAwO1xuICBwYWRkaW5nLWJvdHRvbTogMTAwJTsgKi9cbn1cblxuLnNob3J0Y3V0cy1jb250YWluZXIge1xuICAvKiB3aWR0aDogMzUlOyAqL1xufVxuXG5AbWVkaWEgKG1heC13aWR0aDogMTIwMHB4KSB7XG4gIC5zaG9ydGN1dHMtY29udGFpbmVyIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuXG4gIC5zaG9ydGN1dHMtZ3JpZCB7XG4gICAgZGlzcGxheTogaW5saW5lLWdyaWQ7XG4gICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxZnIgMWZyIDFmciAxZnI7XG4gICAgZ2FwOiAyMHB4O1xuICB9XG59XG5cbi5wYXltZW50LWljb24taXRlbSB7XG4gIG1heC13aWR0aDogMzAlO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4xNXMgY3ViaWMtYmV6aWVyKDAuNjgsIC0wLjU1LCAwLjI3LCAxLjU1KTtcbn1cblxuLnBheW1lbnQtaWNvbi1pdGVtOmhvdmVyIHtcbiAgdHJhbnNmb3JtOiBzY2FsZSgxLjEpO1xuICBvcGFjaXR5OiAxO1xufVxuXG4ucGF5bWVudC1pY29uLWl0ZW0uaW5hY3RpdmUge1xuICB0cmFuc2l0aW9uOiBhbGwgMC4xNXMgY3ViaWMtYmV6aWVyKDAuNjgsIC0wLjU1LCAwLjI3LCAxLjU1KTtcbn1cblxuLnBheW1lbnQtaWNvbi1pdGVtLmluYWN0aXZlOmhvdmVyIHtcbiAgdHJhbnNmb3JtOiBzY2FsZSgxLjEpO1xuICBvcGFjaXR5OiAxO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/portal/view/portal-identity/portal-identity.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB;yBACuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,sCAAsC;IACtC,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA,w2DAAw2D","sourcesContent":[".shortcuts-grid {\n  display: inline-grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.shortcuts-grid .shortcut-item {\n  position: relative;\n  width: 100%;\n  min-height: 160px;\n  border-radius: 35px;\n  /* height: 0;\n  padding-bottom: 100%; */\n}\n\n.shortcuts-container {\n  /* width: 35%; */\n}\n\n@media (max-width: 1200px) {\n  .shortcuts-container {\n    width: 100%;\n  }\n\n  .shortcuts-grid {\n    display: inline-grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: 20px;\n  }\n}\n\n.payment-icon-item {\n  max-width: 30%;\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.payment-icon-item:hover {\n  transform: scale(1.1);\n  opacity: 1;\n}\n\n.payment-icon-item.inactive {\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.payment-icon-item.inactive:hover {\n  transform: scale(1.1);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
